import axios from 'axios';
import { BACKEND_API } from 'global/environment';

/**
 * Generate PDF report for investment calculator
 * @param {string} firstName - User's first name
 * @param {string} email - User's email address
 * @param {Object} calculatorData - Calculator data with investments
 * @param {string} calculatorData.language - Language ('en' or 'mk')
 * @param {Array} calculatorData.investments - Array of investment objects
 * @param {string} turnstileToken - Cloudflare Turnstile verification token
 * @returns {Promise<Blob>} PDF file as blob
 */
export async function generatePDF(firstName, email, calculatorData, turnstileToken) {
  try {
    // Ensure proper URL construction - avoid double slashes
    const baseUrl = BACKEND_API.endsWith('/') ? BACKEND_API.slice(0, -1) : BACKEND_API;
    const endpoint = `${baseUrl}/api/calculator/generate-pdf`;

    const response = await axios.post(
      endpoint,
      {
        firstName,
        email,
        calculatorData,
        turnstileToken,
      },
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Try to parse error message from blob
      try {
        const errorText = await error.response.data.text();
        const errorJson = JSON.parse(errorText);
        throw new Error(errorJson.message || 'Failed to generate PDF');
      } catch (parseError) {
        // If parsing fails, throw generic error
        throw new Error('Failed to generate PDF');
      }
    }
    throw error;
  }
}
